import { Component, OnInit, Input, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { StageSandbox } from '../../services/stage.sandbox';

import * as stageTypes from '../../types';
import * as animations from '../../../shared/animations';
import * as commonTypes from '../../../shared/types';
import * as _ from 'lodash';
import { QUESTION_TYPES } from '../../types/constants';

import { Subscription, Observable } from 'rxjs/Rx';

@Component({
  selector: 'tr-error-stage-container',
  templateUrl: './error-stage-container.component.html',
  //styleUrls: ['./error-stage-container.component.scss']
})
export class ErrorStageContainerComponent implements OnInit {
  @Input() entity: stageTypes.IPage;
  
  private subscriptions: Array<Subscription> = [];
  private currentAction: string = '';
  private blockContainers: stageTypes.IContainerDef[] = [];
  private currentStageId$: Observable<number> = this.sb.getCurrentStageId$();

  constructor(private sb: StageSandbox) { }

  ngOnInit() {
    this.blockContainers = [].concat(this.sb.groupElements(this.entity));
  }

  isDownloading$(questionId: string): Observable<boolean> {
    return this.sb.getFileDownloadingStatus$(questionId, this.currentAction);
  }

  currentAction$(): Observable<string> {
    return Observable.of(this.currentAction);
  }

  viewedDocumentStatus$(questionId: number): Observable<boolean> {
    return this.sb.getFileReadingStatus$(questionId);
  }

  getFileContent$(questionId: number): Observable<any> {
    return this.sb.getFileContent$(questionId);
  }

  onElementAction(actionName: string, question: stageTypes.IHtmlElement) {
    this.currentAction = actionName.toLowerCase();
    this.subscriptions.push(
      this.sb.onDocumentAction(actionName, question.id)
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/stage/containers/error-stage-container/error-stage-container.component.ts